import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Field } from "redux-form";
import AutoCompleteField from "MODULES/shared/components/Forms/AutoCompleteField/AutoCompleteField";
import { SECOND_SELLER_ID, SELLER_ID } from "MODULES/SalesOrders/constants";
import * as actions from "./actions";

function SellersSection({
  searchSellers,
  selectedSeller,
  selectedSecondSeller,
  disabled
}) {
  return (
    <div>
      <Row className="row-col-gutters-half">
        <Col md={5}>
          <div className="form-group">
            <Field
              name={SELLER_ID}
              label="Seller"
              placeholder="Search by name..."
              component={AutoCompleteField}
              search={searchSellers}
              formatItem={result => result && result.full_name}
              disabled={disabled}
              selectedItem={selectedSeller}
              required
            />
          </div>
        </Col>
        <Col md={5}>
          <Field
            name={SECOND_SELLER_ID}
            label="2nd Seller"
            placeholder="Search by name..."
            component={AutoCompleteField}
            search={searchSellers}
            selectedItem={selectedSecondSeller}
            formatItem={result => result && result.full_name}
            disabled={disabled}
          />
        </Col>
      </Row>
    </div>
  );
}

SellersSection.propTypes = {
  disabled: T.bool,
  searchSellers: T.func.isRequired,
  selectedSeller: T.shape({ full_name: T.string }),
  selectedSecondSeller: T.shape({ id: T.number, full_name: T.string })
};

export default connect(undefined, { searchSellers: actions.searchSellers })(
  SellersSection
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/FormSections/SellersSection/SellersSection.jsx